import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';
import BrandItemComponent from './BrandItemComponent';

class BrandsListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sortBy: '',
      sortAsc: false,
      brands: TotemActions.getBrands()
    };
  }

  componentWillMount() {
    TotemStore.on('BRANDS_RECEIVED', this._onReceiveBrands.bind(this));
  }

  componentDidMount() {
  }

  _onReceiveBrands() {
    this.setState({
      brands: TotemStore.getBrands(),
      loading: false
    });
  }

  _handleSortBy(sort) {
    let sortAsc = this.state.sortBy === sort ? !this.state.sortAsc : true;
    this.setState({
      sortBy: sort,
      sortAsc: sortAsc
    });
  }

  render() {
    let { brands } = this.state;
    let { sortBy } = this.state;
    let { sortAsc } = this.state;
    let items = [];

    if (sortBy != '') {
      brands.sort((a, b) => {
        if (sortAsc) {
          if (a[sortBy] < b[sortBy])
            return -1;
          if (a[sortBy] > b[sortBy])
            return 1;
          return 0;
        } else {
          if (a[sortBy] > b[sortBy])
            return -1;
          if (a[sortBy] < b[sortBy])
            return 1;
          return 0;
        }
      });
    }

    if (brands) {
      items = brands.map((brand) => {
        return <BrandItemComponent brand={brand} key={brand.id} sortBy={this.state.sortBy} />
      });
    }

    return (
      <table className="striped z-depth-2">
        <thead>
          <tr>
            <th onClick={this._handleSortBy.bind(this, 'name')}>
              <div>
                <span>
                  Nombre de la sucursal
                </span>
                <i className={sortBy == 'name' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th>
              <div>
                <span>
                  Acciones
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </table>
    );
  }
}

export default BrandsListComponent;


// WEBPACK FOOTER //
// ./src/components/BrandsListComponent.js